export const flatButtonFragment = `
  fragment flatButtonFragment on FlatButtonRecord {
    __typename
    id
    text
    variant
    anchor
    blogArticle {
      previewUrl
    }
    gaEvent {
      ...gaEventFragment
    }
    io
    link
    route {
      page {
        __typename
      }
      path
      updatedPath
    }
    iconName
    iconColor
    iconPlacement
  }
`;
